


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SplitScreen extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: 'https://picsum.photos/id/391/864/900' }) readonly backgroundImage!: string;

  get sideStyle() {
    return {
      'background-image': `url(${this.backgroundImage})`,
      'background-repeat': `no-repeat`,
      'background-size': `cover`,
    };
  }
}
